import { connect } from 'react-redux';
import {
  toggleModal,
  toggleSnackBar,
  getSensorAuthorizations
} from 'state/callers';

import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { myAccountSelector } from 'state/selectors/account';

import MultipleConnectivityIssuesBar from './MultipleConnectivityIssuesBar';
import { dispatchify } from 'common/utils/utils';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  return {
    gitIntegrations: gitIntegrationsSelector(state),
    account: myAccountSelector(state)
  };
};

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    toggleModal,
    toggleSnackBar,
    getSensorAuthorizations
  })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(MultipleConnectivityIssuesBar));
